import * as React from 'react';

declare const require: any;
const FieldModulesLoader = require('../../../_common/platform/jsx/mixins/FieldModulesLoader');

import { IGlob } from '../ts/Glob';

class ComponentRendererLoader extends React.Component<
    {
        fieldsDict: {
            main: { module: string };
        };
        componentProps: any;
        glob: IGlob;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = FieldModulesLoader.getInitialState(props);
    }

    loadModules(fieldsDict) {
        return FieldModulesLoader.loadModules.call(this, fieldsDict);
    }

    cancelModulesLoad() {
        return FieldModulesLoader.cancelModulesLoad.call(this);
    }

    componentDidMount() {
        return FieldModulesLoader.componentDidMount.call(this);
    }

    componentWillUnmount() {
        return FieldModulesLoader.componentWillUnmount.call(this);
    }

    componentWillReceiveProps(nextProps) {
        return FieldModulesLoader.componentWillReceiveProps.call(this, nextProps);
    }

    render() {
        const moduleName = this.props.fieldsDict.main.module;

        const componentModule = this.state.fieldModules[moduleName];
        if (componentModule == null) {
            return null;
        }

        const Component = componentModule.default != null ? componentModule.default : componentModule;

        return <Component glob={this.props.glob} {...this.props.componentProps} />;
    }
}

export default class ComponentRenderer extends React.Component<
    {
        moduleName: string;
        componentProps: any;
        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    render() {
        const fieldsDict = {
            main: { module: this.props.moduleName }
        };

        return (
            <div className="platform-component-renderer">
                <ComponentRendererLoader
                    fieldsDict={fieldsDict}
                    componentProps={this.props.componentProps}
                    glob={this.props.glob}
                />
            </div>
        );
    }
}
